export const docEnum = {
    dpa: 'DPA',
    eula_portal: 'EULA Portal',
    eula_app: 'EULA App',
    pp_clinic: 'Privacy Policy Clinic',
    pp_patient: 'Privacy Policy Patient',
};